<template>
    <div class="hero _home">
      <media-type  :className="'hero-home-media-type'" :obj="homeData.media.media" v-if="!isMobile" :dynAlt="'NOSSA Agência de Comunicação'" :full="true"></media-type>
      <media-type  :className="'hero-home-media-type'" :obj="homeData.media_mob.media_mob" v-if="isMobile" :dynAlt="'NOSSA Agência de Comunicação'"></media-type>

      <div class="main-headline">

        <div class="master-headline">
          <h1 >
            <span class="head-line-orange">
               {{homeData.headline.orange[lang].name}}
            </span><br>
            <span class="head-line-white">
            {{homeData.headline.white[lang].name}}
          </span>
           </h1>

        </div>
        <h4 style="display: block;" class="sub-headline">{{homeData.subheadline[lang].name}}</h4>
      </div>


    </div>
</template>

<script>



    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../../main';
    import MediaType from "./MediaType";


    export default {

        name: 'hero-home',
      components: {MediaType},
      props: ['lang', 'homeData', 'incPagePos', 'isMobile'],
      watch: {
        'incPagePos': function () {

        //  this.reposText(this.incPagePos);

        }
      },

        data() {
            return {
                actScreen: 0


            }
        },

        created() {

          console.log(this.homeData);




        },
        mounted() {

            //EVENTBUS.$on('AAA', AAA);
            //EVENTBUS.$emit('AAA', 0);

          TweenMax.to( '.master-headline', 1, {delay:0.5, y: 0 , opacity: 1, force3D: true, ease: "circ.out"} );
          TweenMax.to( '.sub-headline', 1, {delay:0.8, y: 0 , opacity: 1, force3D: true, ease: "circ.out"} );
        //  this.init();

              },

        destroyed() {

        },

        methods: {

            init() {
              TweenMax.to( '.master-headline', 1, { x: '80%' , force3D: true, ease: Back.easeOut.config(1.4), onComplete:function() {

                }} );

             // TweenMax.to( '.sub-headline', 1, { x: '-60%' , force3D: true, ease:Back.easeOut.config(1.4)} );

            },


          reposText(n){

              let pos1 =  80 - (n * 0.4);
              let pos2 =  -110 + (n * 0.4);

              if(pos1 <= 0){
                pos1 = 0;
              }


            if(pos2 >= 0){
              pos2 = 0;
            }

              console.log(pos2)

            TweenMax.to( '.master-headline', 1, { x: pos1 +'%' , force3D: true, ease: "circ.out"} );
            TweenMax.to( '.sub-headline', 1, { x: pos2 +'%' , force3D: true, ease: "circ.out"} );

          },


        },
    };

</script>


// WEBPACK FOOTER //
// src/components/Modules/HeroHome.vue